<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>-修模列表</b></p>

            <div style="display:inline-block">
                <el-radio-group v-model="statusSearch" @input="searchByStatus">
                    <el-radio-button label="0">修模</el-radio-button>

                    <el-radio-button label="1">完成</el-radio-button>
                    <el-radio-button label="-1">全部</el-radio-button>
                </el-radio-group>
            </div>

            <div style="display:inline-block;width: 300px;">
                <el-input placeholder="请输入模号" v-model="queryValue" class="input-with-select">
                    <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button>
                </el-input>
            </div>

        </div>

        <el-table :data="repairList" style="width: 2000px;" ref="plasticTable" highlight-current-row v-loading="loading"
            element-loading-text="加载中" @selection-change="handleSelectionChange">

            <el-table-column prop="moldCode" label="模具编号" width="150">
            </el-table-column>

            <el-table-column prop="productName" label="产品名称" width="400">
                <template slot-scope="scope">
                    <div v-html="scope.row.productName"></div>
                </template>
            </el-table-column>

            <el-table-column prop="remark" label="备注" width="430">
            </el-table-column>

            <el-table-column prop="creator" label="创建人" width="100">
            </el-table-column>
            <el-table-column prop="createdTime" label="创建日期" width="150">
            </el-table-column>

            <el-table-column prop="status" label="状态" width="140">
            </el-table-column>

            <el-table-column prop="completer" label="完成人" width="100">
            </el-table-column>
            <el-table-column prop="completeTime" label="完成日期" width="150">
            </el-table-column>

        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount"
                layout="total, sizes, prev, pager, next" :total="total" @current-change="pageClick"
                :page-sizes="[10, 15, 20, 25]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

    </div>
</template>

<script>
export default {
    name: "MoldRepair",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),

            repairList: [],

            statusSearch: 0,

            queryValue: '',

            loading: false,

            formLabelWidth: '120px',

            multipleSelection: [],

            pageIndex: 0,
            pageNum: 10,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        handleSelectionChange(val) {
            
            this.multipleSelection = val
        },
        searchOrder(query) {

            this.repairList = []
            this.pageIndex = 0

            if (this.queryValue !== '') {

                this.loading = true

                setTimeout(() => {

                    this.getAll(this.statusSearch)
                }, 200)

            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removePlasticOrder(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        searchByStatus(val) {
            this.pageIndex = 0
            
            this.getAll(val)
        },
        getAll(val) {

            this.$axios({
                method: "post",
                url: "/shiro/mold/repair/getAll",
                data: {
                    statusStr: val,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    queryParam: this.queryValue,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.repairList = data.data

                this.total = this.repairList.length > 0 ? this.repairList[0].total : 0

                for (let i in this.repairList) {
                    this.repairList[i].createdTime = this.$moment(this.repairList[i].createdTime).format("YYYY-MM-DD")

                    var ct = this.repairList[i].completeTime

                    this.repairList[i].completeTime = ct == null ? '' : this.$moment(ct).format("YYYY-MM-DD")

                    if (this.repairList[i].status == 0) {
                        this.repairList[i].status = '修模'
                    } else {
                        this.repairList[i].status = '完成'
                    }

                }

                this.loading = false
            })
        },
        pageClick(currentPage) {
            this.repairList = []

            this.pageIndex = (currentPage - 1) * this.pageNum

            this.getAll(this.statusSearch)
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAll(this.statusSearch)
        },
    },
    mounted() {

        this.setDefaultPath('/moldRepair')

        this.getAll(this.statusSearch)
    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.el-pagination__total {
    color: green;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 118px;
    height: 118px;
    line-height: 118px;
    text-align: center;
}

.el-radio input[aria-hidden="true"] {
    display: none !important;
}

.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
}
</style>